import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestHistoryRowDataI } from '../constants/constants';
import { SeriesOptionsType } from 'highcharts';
import { categoryPercentageSettings, ticketGenerationSourceSettings, humanSouceSettings, avgResolveTimeVsPrioritySettings, avgResolveTimeVsSeveritySettings, getAssigmentGroupDistributionSettings, getMostCommonIssuesSettings, getTicketPerHourSettings, getTicketPerWeekSettings, getComplexityAgentsSettings, getTicketPerDaySettings } from '../constants/ticket-analysis.constansts';
import * as Highcharts from 'highcharts';
import HighchartsExporting from 'highcharts/modules/exporting';
import HC_more from 'highcharts/highcharts-more';
import { LoaderService } from './loader.service';

HighchartsExporting(Highcharts);
HC_more(Highcharts)

    ; (function (Highcharts: any) {
        /**
         * Create a global getSVG method that takes an array of charts as an
         * argument
         */
        Highcharts.getSVG = function (charts: any) {
            // eslint-disable-next-line prefer-const
            let svgArr: any[] = [],
                top = 0,
                width = 0,
                endWidth = 0;

            Highcharts.each(charts, function (chart: any) {
                let svg = chart.getSVG(),
                    // Get width/height of SVG for export
                    // eslint-disable-next-line prefer-const
                    svgWidth = +svg.match(/^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/)[1],
                    // eslint-disable-next-line prefer-const
                    svgHeight = +svg.match(/^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/)[1];

                svg = svg.replace('<svg', '<g transform="translate(' + width + ', ' + top + ')" ');

                svg = svg.replace('</svg>', '</g>');

                width += svgWidth;
                endWidth = Math.max(endWidth, width);

                if (width === 2 * svgWidth) {
                    width = 0;
                    top += svgHeight;
                }

                svgArr.push(svg);
            });
            top += 400;
            return (
                '<svg height="' +
                top +
                '" width="' +
                endWidth +
                '" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
                svgArr.join('') +
                '</svg>'
            );
        };

        /**
         * Create a global exportCharts method that takes an array of charts as an
         * argument, and exporting options as the second argument
         */
        Highcharts.exportCharts = function (charts: any, options: any) {
            charts.forEach(function (chart: any) {
                chart.update({
                    chart: {
                        borderColor: 'grey',
                        borderWidth: 1.5,
                    },
                    credits: {
                        enabled: false,
                    },
                });
            });

            // Merge the options
            options = Highcharts.merge(Highcharts.getOptions().exporting, options);

            // Post to export server
            Highcharts.post(options.url, {
                filename: options.filename || 'chart',
                type: options.type,
                width: options.width,
                svg: Highcharts.getSVG(charts),
            });
        };
    })(Highcharts);
@Injectable({
    providedIn: 'root',
})
export class CreateNewTicketService {
    public emitSelectedReqHistorySource: Subject<RequestHistoryRowDataI> = new Subject();
    public emitSelectedReqHistoryRecord$: Observable<RequestHistoryRowDataI> =
        this.emitSelectedReqHistorySource.asObservable();
    public selectedTicketRequestRow!: RequestHistoryRowDataI;
    private selectedRequestSubject: Subject<RequestHistoryRowDataI> = new Subject();
    private selectedTicketResponseSubject: Subject<any> = new Subject<any>();
    public dataLoaded = false;
    deleteTicketModal = new BehaviorSubject<any>(null);

    private apiServiceUrl = environment.apiUrl;
    private chartConfigDetails = [
        { dataField: 'categoryPercentage', settings: categoryPercentageSettings },
        { dataField: 'ticketGenerationSource', settings: ticketGenerationSourceSettings },
        { dataField: 'humanVsAutoTicketSource', settings: humanSouceSettings },
        { dataField: 'assignmentGroup', settings: getAssigmentGroupDistributionSettings },
        { dataField: 'ticketPerHour', settings: getTicketPerHourSettings },
        { dataField: 'ticketEachDayWeek', settings: getTicketPerWeekSettings },
        { dataField: 'ticketEachDay', settings: getTicketPerDaySettings },
        { dataField: 'mostCommonIssues', settings: getMostCommonIssuesSettings },
        { dataField: 'avgResolveTimeVsPriority', settings: avgResolveTimeVsPrioritySettings },
        // { dataField: 'avgResolveTimeVsSeverity', settings: avgResolveTimeVsSeveritySettings },
        { dataField: 'complexityVsAgent', settings: getComplexityAgentsSettings }
    ];
    constructor(private http: HttpClient, private loaderService: LoaderService) { }
    public validate(clientName: string, file: File, itsmTool: string, emailId: any, notify: any, submitterName: any): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('clientName', clientName);
        formData.append('multipartFile', file, file.name);
        formData.append('itsmTool', itsmTool);
        formData.append('emailId', emailId);
        formData.append('notify', notify);
        formData.append('submitter',submitterName)
        const url = `${this.apiServiceUrl}/aipo/ticket/analysis/api/validate`;
        return this.http.post(url, formData);
    }


    public SubmitNewTicket(clientName: string, file: File, itsmTool: string, emailId: any, notify: any,submitterName:any): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('clientName', clientName);
        formData.append('multipartFile', file, file.name);
        formData.append('itsmTool', itsmTool);
        formData.append('emailId', emailId);
        formData.append('notify', notify);
        formData.append('submitter',submitterName)
        const url = `${this.apiServiceUrl}/aipo/ticket/analysis/api/submit`;
        return this.http.post(url, formData);
    }

    public getAllTicketRequests(): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/ticket/analysis/api/allRequestId`;

        return this.http.get(url).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    /**
     * this will emit the selected request history
     * @param {RequestHistoryRowDataI} record
     * @memberof RequestHistoryService
     */
    public emitSelectedRequestHistory(record: RequestHistoryRowDataI): void {
        this.emitSelectedReqHistorySource.next(record);
    }

    public setSelectedTestDesignRow(row: RequestHistoryRowDataI, returnObservalbe = false): Observable<any> | void {
        this.selectedTicketRequestRow = row;
        this.selectedRequestSubject.next(row);

        if (returnObservalbe) {
            return this.getSelectedTicketDetails(row.requestId);
        }

        if (row) {
            this.getSelectedTicketDetails(row.requestId).subscribe((res: any) => {
                this.selectedTicketResponseSubject.next(res);
            });
        }
    }

    public getSelectedTicketDetails(requestId: string): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/ticket/analysis/api/reports?requestId=${requestId}`;
        return this.http.get(url).pipe(
            map((response: any) => {
                return response;
            })
        );
    }
    public getSelectedTicketResponse(): Observable<any> {
        return this.selectedTicketResponseSubject.asObservable();
    }
    public downloadUploadTicketFile(requestId: any): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/ticket/analysis/api/download-file?requestId=${requestId}`;
        return this.http.get(url, { responseType: 'blob' }).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    public getSelectedRequest() {
        return this.selectedTicketRequestRow;
    }
    public setOptionsForChart(response: any, settings: any) {
        if (Array.isArray(response) && response.length > 0) {
            response.forEach(item => {
                // Capitalize the first letter of the name field if it's not already capitalized
                if (item.name) {
                    item.name = item.name.charAt(0).toUpperCase() + item.name.slice(1);
                }
            });
            response.sort((a: any, b: any) => {
                if (!isNaN(parseFloat(a.name)) && !isNaN(parseFloat(b.name))) {
                    // If 'name' represents numeric values, convert them to numbers for comparison
                    const nameA = parseFloat(a.name);
                    const nameB = parseFloat(b.name);
                    return nameA - nameB;
                } else {
                    // If 'name' represents weekdays, sort them in the desired order
                    const weekDaysOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
                    return weekDaysOrder.indexOf(a.name) - weekDaysOrder.indexOf(b.name);
                }
            });
            const filteredResponse = response.filter(item => {
                return (item.val !== undefined || item.extensive !== undefined || item.volume !== undefined || item.resolvedTime !== undefined);
            });
            // Map response data to corresponding categories and primary data
            const categories = filteredResponse.map((item: any) => item.name);
            // const primaryData = response.map((item: any) => ({
            //     name: item.name,
            //     y: item.val !== undefined ? item.val : 0,
            // }));            
            // const categories = response.map((item: any) => item.name)
            const primaryData = filteredResponse.map((item: any) => ({
                name: item.name,
                y:
                    item.val !== undefined
                        ? item.val
                        : item.extensive !== undefined
                            ? item.extensive
                            : item.volume !== undefined
                                ? item.volume
                                : item.resolvedTime,
            }));

            const secondaryData = response.map((item: any) => ({
                name: item.name,
                y: item.significant !== undefined ? item.significant : item.responseTime,
            }));
            const hasSignificantData = response.some(
                (item: any) => item.significant !== undefined && item.significant !== null
            );

            const yAxisConfig: any[] = [
                {
                    title: {
                        text: settings.yaxisTitle,
                    },
                    min: 0,
                    max: settings.yAxisMax || undefined,
                    tickInterval: settings.yAxisTickInterval || undefined,
                    type: settings.type || undefined,
                    labels: {
                        ...(settings.hour
                            ? {
                                formatter: function (this: { value: number; }) {
                                    return this.value;
                                },
                            }
                            : {}),
                    },
                    dateTimeLabelFormats: {
                        hour: settings.hour || undefined,
                    }
                },
            ];

            if (hasSignificantData) {
                const secondYAxisConfig = {
                    opposite: true,
                    title: {
                        text: settings.y1axisTitle,
                    },
                    max: settings.yAxisMax || undefined,
                    tickInterval: settings.y1AxisTickInterval || undefined,
                };
                yAxisConfig.push(secondYAxisConfig);
            }

            const options: any = {
                exporting: {
                    enabled: true,
                    chartOptions: {
                        plotOptions: {
                            pie: {
                                dataLabels: {
                                    enabled: true,
                                    format: '{point.name}: {point.y:.2f}%'
                                }
                            },
                            column: {
                                dataLabels: {
                                    enabled: true,
                                    format: '{point.name}: {point.y:.2f}%'
                                }
                            },
                            line: {
                                dataLabels: {
                                    enabled: true,
                                    format: '{point.name}: {point.y:.2f}%'
                                }
                            },
                            gauge: {
                                dataLabels: {
                                    enabled: true,
                                    format: '{point.name}: {point.y:.2f}%'
                                }
                            }
                        }
                    }

                },
                title: {
                    text: settings.title,
                    y: settings.y,
                    align: 'left',
                    // margin: 24,
                    style: { fontWeight: 'bold' },
                },
                chart: {
                    marginTop: 50, // Adj
                    marginBottom: settings.marginBottom
                },
                xAxis: {
                    lineWidth: 0,
                    minorGridLineWidth: 0,
                    lineColor: 'transparent',
                    categories: categories,
                    title: {
                        text: settings.xaxisTitle || '',
                    }
                },
                yAxis: yAxisConfig,
                credits: {
                    enabled: false,
                },
                series: [
                    {
                        name: settings.name1,
                        type: settings.type1,
                        data: (primaryData as SeriesOptionsType[]) || [],
                        color: settings.color1,
                        tooltip: {
                            pointFormat: ' {point.y:.2f} {point.custom.unit}',
                        },
                    },
                ],
            };
            options.plotOptions = {
                line: {
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}',
                    },
                    tooltip: {
                        pointFormat: ' {point.y:.2f} {point.custom.unit}',
                    },
                    colors: [settings.color1, settings.color2],
                    showInLegend: true,
                    jitter: {
                        x: 0.14,
                        y: 0,
                    },
                    marker: {
                        radius: 4,
                        symbol: 'circle',
                        innerSize: '70%',
                        color: '#FFF',
                    },
                    events: {
                        legendItemClick: function () {
                            return false;
                        },
                    },
                },
                column: {
                    events: {
                        legendItemClick: function () {
                            return false;
                        },
                    },
                    showInLegend: true,
                    colors: [settings.color1, settings.color2],
                    tooltip: settings.tooltip || '',
                    dataLabels: settings.dataLabels || '',
                },
                pie: {
                    showInLegend: true,
                    innerSize: '70%',
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: ' {point.y}%',
                    },
                    tooltip: {
                        pointFormat: ' {point.y:.2f} {point.custom.unit}%',
                    },
                    colors: [
                        settings.color1,
                        settings.color2,
                        settings.color3,
                        settings.color4,
                        settings.color5,
                        settings.color6,
                        settings.color7,
                        settings.color8,
                        settings.color9,
                        settings.color10,
                    ],
                    point: {
                        events: {
                            legendItemClick: function () {
                                return false;
                            },
                        },
                    },
                },
            };
            options.series[1] = { color: 'white', name: '' };
            if (settings.name2) {
                const series2: any = {
                    name: settings.name2,
                    type: settings.type2,
                    color: settings.color2,
                    data: secondaryData as SeriesOptionsType[],
                    yAxis: settings.yAxis || undefined,
                };
                options.series[1] = series2;
            } else {
                options.series[1] = { color: 'white', name: '' };
            }

            return options;
        }
    }
    createAndExportCharts(data: any,filename: string) {
        this.loaderService.show();
        const readyCharts2Export: object[] = [];
        this.chartConfigDetails.forEach((chartConfig) => {
            const chartData = data[chartConfig.dataField];
            const settings = chartConfig.settings;
            const chartsOptions = this.setOptionsForChart(chartData, settings);

            if (chartsOptions) {
                readyCharts2Export.push(Highcharts.chart(document.createElement('div'), chartsOptions));
            }
        })
            ; (Highcharts as any).exportCharts(readyCharts2Export, {
                type: 'application/pdf',
                filename:filename
            });
        setTimeout(() => {
            this.loaderService.hide();
        }, 1000);
    }

    public deleteTicketAanalysis(requestId: any): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/ticket/analysis/api/delete?requestId=${requestId}`;
        return this.http.delete(url).pipe(
            map((response: any) => {
                return response;
            })
        );
    }
}
